import { createSlice } from "@reduxjs/toolkit";

const UserDeviceRegistrationSlice = createSlice({
    name: 'GetUserDeviceRegistrationService',
    initialState: {
        loading: false,
        data: null,
        error: null,
        success: false
    },
    reducers: {
        GetUserDeviceRegistrationServiceInit(state) {
            state.loading = true;
            state.error = null;
        },
        GetUserDeviceRegistrationServiceSuccess(state, action) {
            state.loading = false;
            state.success = true;
            state.data = action.payload;
        },
        GetUserDeviceRegistrationServiceFailure(state, action) {
            state.loading = false;
            state.success = false;
            state.error = action.payload;
        },
        GetUserDeviceRegistratoinServiceReset(state) {
            return {...state, loading: false, data: null, success:  false, error: null};
        }
    }
});

export const {
    GetUserDeviceRegistrationServiceInit,
    GetUserDeviceRegistrationServiceSuccess,
    GetUserDeviceRegistrationServiceFailure,
    GetUserDeviceRegistratoinServiceReset
} = UserDeviceRegistrationSlice.actions;

export default UserDeviceRegistrationSlice.reducer;